import { InfiniteSlider } from "@/components/ui/infinite-slider";
import { ProgressiveBlur } from "@/components/ui/progressive-blur";
import { clientLogos } from "@/data/clientLogos";

const ClientLogosSection = () => {
  return (
    <section className="bg-[#FBFAFF] pb-2 md:pb-3 overflow-hidden">
      <div className="group relative m-auto w-full px-6 max-w-full">
        <div className="flex flex-col items-center md:flex-row">
          <div className="md:max-w-44 md:border-r md:pr-6">
            <p className="text-end text-sm">
              Powering the <span className="hidden md:block"></span>
              <span className="md:hidden">best teams</span>
              <span className="hidden md:inline">best teams</span>
            </p>
          </div>
          <div className="relative py-6 md:w-[calc(100%-11rem)] w-full overflow-hidden">
            <InfiniteSlider durationOnHover={20} duration={40} gap={64}>
              {clientLogos.map((logo, index) => (
                <div key={`logo-${index}`} className="flex">
                  <img
                    className="mx-auto h-8 w-fit opacity-80 hover:opacity-100 transition-all duration-300 filter grayscale hover:grayscale-0"
                    src={logo}
                    alt={`Client logo ${index + 1}`}
                    height="32"
                    width="100"
                    loading="eager"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = "none";
                    }}
                  />
                </div>
              ))}
            </InfiniteSlider>

            <div className="bg-gradient-to-r from-background absolute inset-y-0 left-0 w-20"></div>
            <div className="bg-gradient-to-l from-background absolute inset-y-0 right-0 w-20"></div>

            <ProgressiveBlur
              className="pointer-events-none absolute left-0 top-0 h-full w-20"
              direction="left"
              blurIntensity={1}
            />
            <ProgressiveBlur
              className="pointer-events-none absolute right-0 top-0 h-full w-20"
              direction="right"
              blurIntensity={1}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogosSection;
